import React from "react";
import pointsIcon from "../../img/points.png";
import timerIcon from "../../img/timer.png";
import howToPlayIcon from "../../img/how-to-play.png";
import { formatMmSs } from "../../utils/talentPoints";
import "./talentHud.css";

export default function TalentHud({
  score,
  timeSec,
  progressCount,
  progressTotal,
  showProgress = true,
  showHowToPlay = false,
  onHowToPlay,
  inPanel = true,
  btnStyle,
}) {
  const progressPct =
    progressTotal > 0 ? Math.round((progressCount / progressTotal) * 100) : 0;

  return (
    <div
      className={`yoga-hud-card${inPanel ? "" : " yoga-hud-card--standalone"}`}
    >
      <div className="yoga-hud-row">
        <div className="yoga-hud-stat yoga-hud-stat--score">
          <img src={pointsIcon} alt="" className="yoga-hud-icon" />
          <div>
            <div className="yoga-hud-label">Score</div>
            <div className="yoga-hud-value">{score}</div>
          </div>
        </div>

        {showProgress ? (
          <div className="yoga-hud-stat yoga-hud-progress-wrap yoga-hud-progress-wrap--center">
            <div className="yoga-hud-progress-inner">
              <div className="yoga-hud-label">Progress</div>
              <div className="yoga-hud-progress-line">
                <div className="yoga-hud-progress-bar">
                  <div
                    className="yoga-hud-progress-fill"
                    style={{ width: `${progressPct}%` }}
                  />
                </div>
                <div className="yoga-hud-value yoga-hud-value--progress">
                  {progressCount}/{progressTotal}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="yoga-hud-progress-wrap yoga-hud-progress-wrap--center" />
        )}

        <div className="yoga-hud-right">
          <div className="yoga-hud-stat yoga-hud-stat--timer">
            <img src={timerIcon} alt="" className="yoga-hud-icon" />
            <div className="yoga-hud-value">{formatMmSs(timeSec)}</div>
          </div>
          {showHowToPlay ? (
            <button
              type="button"
              className="yoga-hud-how-to-play"
              onClick={onHowToPlay}
              aria-label="How to play"
            >
              <img src={howToPlayIcon} alt="" />
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
